/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useMemo, useRef, useEffect } from 'react';
import I18n from 'I18n';
import { getConfig } from 'tinymce-config/configs/editors/knowledge-base';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import makeAsyncEmojiPickerContent from 'ui-addon-emoji-picker/picker/makeAsyncEmojiPickerContent';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'reac... Remove this comment to see the full error message
import TinyMce from 'react-tinymce';
import tracker from '../../../utils/UsageTracker';
import FileManager from '../../FileManager';
import FilePicker from '../../FilePicker';
import ArticlePlaceholder from './ArticlePlaceholder';
import { makeAsyncComponent } from '../../../utils/asyncUtils';
import { SELECTION_COMMANDS } from 'content-assistance-lib/toolbars/commands';
import { selectArticleLanguage } from '../../../selectors/edit';
import { getCanUseAIGeneratedContent, getIsContentAssistanceEnabled, getIsContentAssistanceRequestPending } from '../../../selectors/contentAssistant';
import { getContentAssistantSettings } from '../../../actions/ContentAssistantActions';
import { useAppDispatch, useAppSelector } from '../../../utils/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const pickerComponents = {
  CtaPicker: makeAsyncComponent(() => import( /* webpackChunkName: 'cta-picker' */'cta-picker/components/CTAPicker')),
  EmojiPicker: makeAsyncEmojiPickerContent(() => import(
  // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
  /* webpackChunkName: 'emoji-picker' */
  'ui-addon-emoji-picker/picker/EmojiPickerContent')),
  FilePicker,
  HubSpotVideoPicker: makeAsyncComponent(() => import( /* webpackChunkName: 'video-picker' */'media-bridge-lib/components/media-picker/HubSpotVideoPicker'))
};
const AsyncContentAssistantToolbar = makeAsyncComponent(() => import( /* webpackChunkName: "ContentAssistanceToolbar" */'knowledge-content-ui/containers/ContentAssistanceToolbarContainer'));
function KbTinyMCE(props) {
  const {
    className,
    gates,
    onBlur,
    onChange,
    onFocus,
    onKeyUp,
    initialContent,
    scopes,
    readOnly
  } = props;
  const dispatch = useAppDispatch();
  const language = useAppSelector(selectArticleLanguage);
  const canUseAIGeneratedContent = useAppSelector(getCanUseAIGeneratedContent);
  const isContentAssistanceEnabled = useAppSelector(getIsContentAssistanceEnabled);
  const isContentAssistanceRequestPending = useAppSelector(getIsContentAssistanceRequestPending);
  useEffect(() => {
    if (isContentAssistanceEnabled === null && !isContentAssistanceRequestPending) {
      dispatch(getContentAssistantSettings());
    }
  }, [dispatch, isContentAssistanceEnabled, isContentAssistanceRequestPending]);
  const tinyMceRef = useRef(null);
  const config = useMemo(() => {
    return getConfig({
      appName: 'knowledge-base',
      gates,
      FileManagerComponent: FileManager,
      pickerComponents: Object.assign({}, pickerComponents, {
        ContentAssistanceToolbar: loadableProps => {
          return /*#__PURE__*/_jsx(AsyncContentAssistantToolbar, Object.assign({}, loadableProps, {
            language: language
          }));
        }
      }),
      scopes,
      toolbarContainer: '#tinymce-toolbar',
      usageTracker: tracker,
      maxContainerWidth: 688,
      h1Tooltip: I18n.text('knowledgeContentUI.edit.toolbar.disabledH1Tooltip'),
      h2Tooltip: I18n.text('knowledgeContentUI.edit.toolbar.disabledH2Tooltip'),
      toolbarTooltip: I18n.text('knowledgeContentUI.edit.toolbar.disabledToolbarTooltip'),
      stripImageBlobs: true,
      useContentGeneration: canUseAIGeneratedContent,
      hsContentAssistant: {
        selectionCommands: [SELECTION_COMMANDS.KB_REPHRASE, SELECTION_COMMANDS.KB_EXPAND_IDEA, SELECTION_COMMANDS.KB_SUMMARIZE_IDEA, SELECTION_COMMANDS.KB_CHANGE_TONE]
      }
    });
  }, [gates, scopes, canUseAIGeneratedContent, language]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: !isContentAssistanceRequestPending && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(TinyMce, {
        className: className,
        config: config,
        content: initialContent,
        inline: true,
        onChange: onChange,
        onKeyUp: onKeyUp,
        onFocus: onFocus,
        onBlur: onBlur,
        renderPlaceholder: () => /*#__PURE__*/_jsx(ArticlePlaceholder, {
          onClick: () => {
            // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
            tinyMceRef.current.editor.focus();
          }
        }),
        readOnly: readOnly,
        tinyMceRef: ref => {
          tinyMceRef.current = ref;
        }
      })
    })
  });
}
export default KbTinyMCE;